import React, {useEffect, useRef, useState} from 'react';
import CardHeader from '../../components/common/card-header/CardHeader';
import {
    Card,
    FlexItem,
    FlexLayout, Spinner,
    StackLayout, Text,
} from '@salt-ds/core';
import StepTracker from '../../components/common/StepTracker';

import '../CommonCard.css';
import Constants from '../../components/common/Constants';
import CardAlert from '../../components/common/card-alert/CardAlert';
import {useLocation, useNavigate} from 'react-router';
import PageNavigation from '../../components/common/page-navigation/PageNavigation';
import {deRegisterDevice, success} from "../../api/LoginApi";
import PasswordExpiringSoonModal from '../../components/common/PasswordExpiringSoonModal';
import {useIntl} from 'react-intl';


function RegisterComputerComplete(props) {

  const location = useLocation();
  const navigate = useNavigate();
  const [hasError, setHasError] = useState(true);
  const [passwordExpiryFormData, setPasswordExpiryFormData] = useState({daysUntilNextReminder: 90});
  const [isLoading, setIsLoading] = useState(false);
  const [showRedirect, setShowRedirect] = useState(false);
  const [showBanner, setShowBanner] = useState(true);
  const [isContinuDisabled, setIsContinueDisabled] = useState(false);
  const mainRef = useRef(null);
  const intl = useIntl();

  useEffect(() => {
    document.title = intl.formatMessage({id: 'logon.ui.registercomputer.step3.page.title'});
    // Set focus to main element for screen reader announcement
    if (mainRef.current) {
      mainRef.current.focus();
    }

    if (location.state?.from !== Constants.registerComputerOptions) {
      navigate('/');
    }

  }, [location, navigate]);

  const { registerDevice } = location.state || {};

  useEffect(() => {
    if (registerDevice != null && registerDevice === false) {
      console.log('Calling deRegisterDevice because registerDevice is false');
      deRegisterDevice("abc","abc", "abc").then((response) => {
        if (response.status === 200) {
          setHasError(false);
        } else {
          setHasError(true);
        }
      }).catch((error) => {
        setHasError(true);
      });
    }
    // Only run when registerDevice changes
  }, [registerDevice]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    const passwordExpiryData = await success(sessionStorage.getItem("orgName"), sessionStorage.getItem("loginName"));
    if (passwordExpiryData.data.reminderRequired) {
      setPasswordExpiryFormData({...passwordExpiryData.data});
      props.fillAndOpenModel(
          <PasswordExpiringSoonModal
              closeAndClearModal={props.closeAndClearModal}
              fillAndOpenModel={props.fillAndOpenModel}
              passwordExpiryFormData={passwordExpiryData.data} setShowRedirect={setShowRedirect} useTargetRedirect={false}
            onRemindMeLater={() => setIsContinueDisabled(true)} />
      );
        setIsLoading(false);  // Hide spinner if modal is shown
    }
    else {
      window.location.href = `${window.location.origin}/card/home`;
    }
    if(showRedirect)
    {
      window.location.href = `${window.location.origin}/card/home`;
    }
  };

    const [headerContent,setHeaderContent ] = useState(
        registerDevice ? (
            <CardAlert setShowBanner={setShowBanner} status="success" setHasError={setHasError}>
                Your web browser is now registered with your User ID. Select <b>Continue</b> to log into your account
            </CardAlert>
        ) : (
            <CardAlert setShowBanner={setShowBanner} status="info" setHasError={setHasError}>
                Your web browser was not registered with your User ID. Select <b>Continue</b> to log into your account.
            </CardAlert>
    )
    );

  return (
    <main ref={mainRef} role="main" aria-label="Register Computer Complete" tabIndex="-1">
      <FlexLayout className={"page-content"}>
        {isLoading || showRedirect ? (
            <FlexItem className="spinner-wrapper">
                <Spinner data-testid="spinner-loading" aria-label="loading" role="status" size="medium" style={{marginLeft: "50%"}} />
            </FlexItem>
        ) : (
            <FlexItem className={`error-wrapper ${showBanner ? 'visible' : ''}`} >
                {headerContent}
            </FlexItem>
        )}
        <FlexItem>
          <Card className="card-wrapper">
            <FlexItem className="card-content">
              <StackLayout gap={5}>
                <CardHeader heading={Constants.registerComputerTitle} subheading={Constants.registerComputerStep3Title}
                  style={{maxWidth: "20rem"}} />
                <StepTracker label1={intl.formatMessage({id: 'logon.ui.registercomputer.flow.step1'})} step1="completed"
                             label2={intl.formatMessage({id: 'logon.ui.registercomputer.flow.step2'})} step2="completed"
                             label3={intl.formatMessage({id: 'logon.ui.registercomputer.flow.step3'})} step3="completed" />
                <FlexItem>
                  <Text >
                    {registerDevice? Constants.registerComputerStep3RegisterMyComputerInstructionHeader : Constants.registerComputerStep3DoNotRegisterMyComputerInstructionHeader}
                  </Text>
                </FlexItem>
                <FlexItem>
                  <Text >
                    {registerDevice ? Constants.registerComputerStep3RegisterMyComputerInstructionHeaderNote : Constants.registerComputerStep3DoNotRegisterMyComputerInstructionHeaderContinue}
                  </Text>
                </FlexItem>
              </StackLayout>
              <PageNavigation isContinue={true} buttonText="CONTINUE" style={{marginTop: "25%"}} sendToHome={handleSubmit} disabled={isLoading || isContinuDisabled} />
            </FlexItem>
          </Card>
        </FlexItem>
    </FlexLayout>
    </main>
  );
}

export default RegisterComputerComplete;